export default {
  subheadline: 'Diese Seite erlaubt es die benutzerdefinierten Bedeutungen für Ihre eigenen Zwecke anzupassen. Die Änderungen werden für alle Benutzer sichtbar.',
};
